import React, { useEffect, useState } from 'react';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import '../Component-Library.scss';
import CTASelector from '../../../../shared/ui-builder/cta-selector/CTA-Selector';
import { BUTTON_W_CTA } from '../../../../constants/UiBuilderConst';

const CtaButton1 = (props) => {
  const { onItemChange, config, handleError, componentNdx } = props;

  const initialState = {
    cta: {
      isActive: true,
      title: '',
    },
    redirectLink: {
      connection: '',
      linkId: '',
      isActive: true,
      flowSubSelection: '',
    },
  };

  const [configState, setConfigState] = useState(config?.cta?.title ? config : initialState);
  const [error, setError] = useState(null);

  useEffect(() => {
    onItemChange({
      componentName: BUTTON_W_CTA,
      config: configState,
    });
  }, [configState]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === BUTTON_W_CTA,
      );
      setError(currError ?? null);
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    } else {
      return val?.type ? '' : 'required';
    }
  };

  const handleTabData = (val, slideContent, field) => {
    const actual = field === 'ctaTitle' && typeof val === 'string' ? val?.trim() : val;
       if (error) {
    setError((prev) => {
       const base = prev || { config: {} };
       const next = { ...base, config: { ...base?.config } };
       const status = setErrorField(field, actual); 
       if (field === 'ctaTitle' || field === 'redirect') {
         next.config[field] = status;
         if (field === 'ctaTitle') next.config.CTA = status;
       }
       return next;
     });
   }

    if (field === 'redirect') {
      setConfigState((prev) => ({
        ...prev,
        redirectLink: {
          connection: val?.type,
          linkId: val?.value,
          isActive: prev?.redirectLink?.isActive,
          flowSubSelection: val?.flowSubSelection,
        },
      }));
    } else if (field === 'ctaTitle') {
      setConfigState((prev) => ({
        ...prev,
        cta: {
          isActive: prev?.cta?.isActive,
          title: actual,
        },
      }));
    }
  };

  return (
    <div className='row my-2 mx-4'>
      <div className='col-md-12'>
        <div className='col-md-10 mt-4'>
          <CTASelector
            areButtonsDisabled={true}
            onValueChange={(e) => handleTabData(e, configState, 'ctaTitle')}
            isLabelDisabled={true}
            value={configState.cta.title}
            onCTAStatusChange={(e) => {
              handleTabData(e, configState, 'isCTAActive');
            }}
            isActive={configState.cta.isActive}
            error={(error?.config?.ctaTitle ?? error?.config?.CTA) === 'required'}
          />
        </div>
        <div className='col-md-12 mt-4'>
          <RedirectSelector
            areButtonsDisabled={true}
            onValueChange={(e) => handleTabData(e, configState, 'redirect')}
            redirectType={configState.redirectLink.connection}
            value={configState.redirectLink.linkId}
            onRedirectChange={(e) => {
              handleTabData(e, configState, 'isActive');
            }}
            isActive={configState.redirectLink.isActive}
            error={error?.config?.redirect === 'required' ? true : false}
            showFlowSubSelection={true}
            flowSubSelection={configState.redirectLink.flowSubSelection}
          />
        </div>
      </div>
    </div>
  );
};

export default CtaButton1;
